import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { translate } from '@jsverse/transloco';
import { AppNotificationService } from 'src/app/shared/services/notification.service';
import { ICreateTenantRequest, ITenant, IUpdateTenantRequest } from '../tenant';
import { TenantService } from '../tenant.service';

@Component({
    selector: 'app-tenant',
    templateUrl: './tenant.component.html',
    styleUrls: ['./tenant.component.css'],
    standalone: false
})
export class TenantComponent implements OnInit {

  constructor(
    private route : ActivatedRoute,
    private tenantService: TenantService,
    private appnotificationService: AppNotificationService
  ) { }

  tenants: ITenant[];

  public formGroup!: UntypedFormGroup;

  private editedRowIndex!: number;

  selectedTenant: ITenant = null;
  isAddingNew = false;

  maxDateRange = new Date(new Date().setFullYear(new Date().getFullYear() + 3));

  isDialogActive = false;
  isDialogEditActive = false;

  public updateSubscriptionForm: UntypedFormGroup;
  public updateTenantForm: UntypedFormGroup;

  ngOnInit(): void {
    this.tenants = this.route.snapshot.data.tenants as ITenant[];
    console.log(this.maxDateRange);
  }

  addHandler({ sender }){
    this.isAddingNew = true;
    this.closeEditor(sender);

    this.formGroup = new UntypedFormGroup({
      id: new UntypedFormControl(null, Validators.required),
      name: new UntypedFormControl(null, Validators.required),
      connectionString: new UntypedFormControl(null),
      adminEmail: new UntypedFormControl(null, Validators.required),
      issuer: new UntypedFormControl(null),
    });

    sender.addRow(this.formGroup);
  }

  public saveHandler(event) {
    const request: ICreateTenantRequest = {
      id: event.dataItem.id,
      name: event.formGroup.value.name,
      connectionString: event.dataItem.connectionString ?? null,
      adminEmail: event.dataItem.adminEmail,
      issuer: event.dataItem.issuer ?? null,
    }
    
    this.tenantService.createTenant(request)
    .subscribe(response => {
      this.tenantService.listTenants()
      .subscribe(tenants => this.tenants = tenants)
    })

    event.sender.closeRow(event.rowIndex);
    this.isAddingNew = false;
  }

  private closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }
  
  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
    this.isAddingNew = false;
  }

  onChangeState(tenant){
    console.log(tenant, "change tenant state");
    if(tenant.isActive){
      // deactivate Tenant
      this.tenantService.deactivateTenant(tenant.id)
      .subscribe(response => {
        console.log(response, "res");
        this.tenantService.listTenants()
        .subscribe(tenants => {
          this.tenants = tenants
          this.appnotificationService.notification$.next(
            {message: translate('tenant.saveSuccess'), style: 'success'}
            )
        })
      })
    }
    else {
      // activate Tenant
      this.tenantService.activateTenant(tenant.id)
      .subscribe(response => {
        this.tenantService.listTenants()
        .subscribe(tenants => {
          this.appnotificationService.notification$.next(
            {message: translate('tenant.saveSuccess'), style: 'success'}
            )
          this.tenants = tenants})
      })
    }
  }

  onUpgrade(tenant){
      this.selectedTenant = tenant;
      this.isDialogActive = true;

      this.updateSubscriptionForm = new UntypedFormGroup({
        tenantId: new UntypedFormControl(tenant.id, Validators.required),
        extendedExpiryDate: new UntypedFormControl(new Date(tenant.validUpto), Validators.required),
      });
  }

  closeDialog(){
    this.selectedTenant = null;
    this.isDialogActive = false;
  }

  onCancel(e: PointerEvent){
    e.preventDefault();
    this.closeDialog();
  }

  onEdit(tenant){
    this.selectedTenant = tenant;
    this.isDialogEditActive = true;

    this.updateTenantForm = new UntypedFormGroup({
      tenantId: new UntypedFormControl(tenant.id, Validators.required),
      timeModule: new UntypedFormControl(tenant.timeModule, Validators.required),
      assignmentModule: new UntypedFormControl(tenant.assignmentModule, Validators.required),
      fileModule: new UntypedFormControl(tenant.fileModule, Validators.required),
      expenseModule: new UntypedFormControl(tenant.expenseModule, Validators.required),
      schedulerModule: new UntypedFormControl(tenant.schedulerModule, Validators.required),
      userLicenses: new UntypedFormControl(tenant.userLicenses, Validators.min(0)),
    });
  }
  closeEditDialog(){
    this.selectedTenant = null;
    this.isDialogEditActive = false;
  }

  onCancelEdit(e: PointerEvent){
    e.preventDefault();
    this.closeEditDialog();
  }

  public onSaveEdit(e: PointerEvent): void {
    e.preventDefault();
    const request : IUpdateTenantRequest = {
      ...this.updateTenantForm.value
    }
    this.tenantService.updateTenant(request)
    .subscribe(response => 
      this.tenantService.listTenants()
      .subscribe(tenants => this.tenants = tenants)
    )
    this.isDialogEditActive = false;
  }

  public onSave(e: PointerEvent): void {
    e.preventDefault();
    this.tenantService.upgradeTenant(this.updateSubscriptionForm.value)
    .subscribe(response => 
      this.tenantService.listTenants()
      .subscribe(tenants => this.tenants = tenants)
    )
    this.isDialogActive = false;
  }

  getActiveModules(tenant: ITenant): string {
    const modules = [];
    if (tenant.timeModule) modules.push('Zeit');
    if (tenant.schedulerModule) modules.push('Planung');
    if (tenant.assignmentModule) modules.push('Auftrag');
    if (tenant.fileModule) modules.push('Dateien');
    if (tenant.expenseModule) modules.push('Spesen');
    return modules.join(', ');
  }
}
function UntilDestroy() {
  throw new Error('Function not implemented.');
}

